
export const serviceWorker = (url) => {
  if ('serviceWorker' in navigator) {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    if (!isSafari) {
      // register clevertap service worker
      navigator.serviceWorker.register('/clevertap_sw.js').then(
        function (registration) {
          console.log('Clevertap Service Worker registration successful with scope: ', registration.scope)
        },
        function (err) {
          console.log('Clevertap Service Worker registration failed: ', err)
        }
      )
    } else {
      window.location.href = url
    }
  } else {
    window.location.href = url
  }
}

export const clearSw = (url) => {
  if ('serviceWorker' in navigator) {
    // Unregister all service workers
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (const registration of registrations) {
        registration.unregister()
      }
      window.location.href = url
    }).catch(error => {
      console.error('Error unregistering service workers:', error)
      window.location.href = url
    })
  } else {
    window.location.href = url
  }
}
